import { render } from "./UserButton.vue?vue&type=template&id=2cf48b2e&scoped=true"
import script from "./UserButton.vue?vue&type=script&lang=js"
export * from "./UserButton.vue?vue&type=script&lang=js"

import "./UserButton.vue?vue&type=style&index=0&id=2cf48b2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cf48b2e"]])

export default __exports__